import React from "react";
import "../../../css/DesignSystem/SelectionControls/SelectionControls.css";

const normaliseOptions = (options = [], labelsMap = {}) =>
  options.map((option) => {
    if (typeof option === "object") return option;

    return {
      value: option,
      label: labelsMap?.[option] || option,
    };
  });

const CheckboxGroup = ({
  label,
  options = [],
  values = [],
  onChange,
  columns = 2,
  labelsMap = {},
}) => {
  const parsed = normaliseOptions(options, labelsMap);

  const toggle = (value) => {
    const exists = values.includes(value);

    if (exists) {
      onChange(values.filter((v) => v !== value));
    } else {
      onChange([...(values || []), value]);
    }
  };

  return (
    <div className="smSelectionGroup">
    {label && <div className="FP_Content_Semibold">{label}</div>}

      <div
        className="smSelectionGrid"
        style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
      >
        {parsed.map((opt) => (
          <label key={opt.value} className="smOptionCard">
            <input
              type="checkbox"
              checked={values.includes(opt.value)}
              onChange={() => toggle(opt.value)}
            />
            <span className="smCheckboxBox" />
            <span className="smOptionLabel FP_Content">{opt.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default CheckboxGroup;
